import React from 'react'

function Loading()
{
    return (
        <section className="section loading">
            <h1>Loading....</h1>
        </section>
    )
}

export default Loading